import React, { useEffect } from "react";
import { Notification } from "../common/Notification";
import * as httpClient from "../../util/httpClient";

const TransactionConfirmDeleteAccountDialog = (props: any) => {
    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-transaction-delete");
        cancelBtn.addEventListener("click", () => props.closeDialog("cancel"));
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const deleteAccount = () => {
        if (props.memberInfo['isYodleeUser']) {
            httpClient
                .sendRequest("POST", `api/financial-account/remove-account`, { "monitor-id": props.memberInfo["memberId"] })
                .then((data) => {
                    Notification({
                        type: "success",
                        title: "Delete Account",
                        message: "Account deleted successfully.",
                        duration: 5,
                    });
                    props.closeDialog("close");
                })
                .catch(function (error) {
                    Notification({
                        type: "error",
                        title: "Delete Account",
                        message: "Account delete failed, please try again later.",
                        duration: 5,
                    });
                });
        } else {
            httpClient
                .sendRequest("DELETE", `api/mx/deleteMember/${props.memberInfo["memberId"]}`)
                .then((data) => {
                    Notification({
                        type: "success",
                        title: "Delete Account",
                        message: "Account deleted successfully.",
                        duration: 5,
                    });
                    props.closeDialog("close");
                })
                .catch(function (error) {
                    Notification({
                        type: "error",
                        title: "Delete Account",
                        message: "Account delete failed, please try again later.",
                        duration: 5,
                    });
                });
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon status-default">
                    <em className="las la-trash-alt"></em>
                </div>
                <h1>Confirm Delete</h1>
            </div>
            <div className="dialog-body">
                <p>If you proceed, you will lose all transaction data and alert history for ALL accounts under this Financial Institution. Are you sure you want to delete?</p>
                <p>{props["memberInfo"].memberName}</p>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            id="btn-cancel-transaction-delete"
                            onClick={() => window.addToDataLayer({ event: "Cancel Deleting Account" })}
                            className="btn-default btn-link btn-no-padding btn-no-border"
                        >
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-red"
                            onClick={() => {
                                deleteAccount();
                                window.addToDataLayer({ event: "Confirm Delete Account" });
                            }}
                        >
                            <span className="btn-icon">
                                <em className="las la-trash-alt"></em>
                            </span>
                            <span className="btn-text">Yes, Delete</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default TransactionConfirmDeleteAccountDialog;
